import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { Notification } from '../../Interfaces/Notifications/Notification';
import { actionCreators } from './NotificationsState';
import { Dispatch } from 'redux';
import { NotificationUser } from '../../Interfaces/Notifications/NotificationUser';
import { ReportFilter } from '../../Interfaces/Reports/ReportFilter';

export const fetchNotificationTypes = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.fetchNotificationTypes());
};

export const resetFetchError = async (dispatch: any) => {
  return dispatch(actionCreators.resetFetchError());
};

export const registerNotification = async (
  dispatch: any,
  notificationData: Notification,
) => {
  return dispatch(actionCreators.registerNotification(notificationData));
};

export const updateNotification = async (
  dispatch: any,
  notificationData: Notification,
) => {
  return dispatch(actionCreators.updateNotification(notificationData));
};

export const saveNotificationsFilter = async (
  dispatch: any,
  filters: CompositeFilterDescriptor
) => {
  return dispatch(actionCreators.saveNotificationsFilter(filters));
};

export const resetNotificationsFilter = async (
  dispatch: any
) => {
  return dispatch(actionCreators.resetNotificationsFilter());
};

export const fetchNotificationNames = async (dispatch: Dispatch<any>, notificationType: string) => {
  return dispatch(actionCreators.fetchNotificationNames(notificationType));
};

export const fetchActiveNotifications = async (dispatch: Dispatch<any>, notificationType: string) => {
  return dispatch(actionCreators.fetchActiveNotifications(notificationType));
};

export const updateNotificationActive = async (dispatch: Dispatch<any>, notificationType: string, index: number) => {
  return dispatch(actionCreators.updateNotificationActive(notificationType, index));
}

export const fetchNotificationsRuleData = async (dispatch: Dispatch<any>, notificationType: string, notificationName: string) => {
  return dispatch(actionCreators.fetchNotificationsRuleData(notificationType, notificationName));
}

export const sendUnregisterNotification = async (dispatch: Dispatch<any>, notification: Notification) => {
  return dispatch(actionCreators.sendUnregisterNotification(notification));
};

export const fetchRegisteredUsers = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.fetchRegisteredUsers());
};

export const registerUser = async (
  dispatch: any,
  userData: NotificationUser,
) => {
  return dispatch(actionCreators.registerUser(userData));
};
export const updateUser = async (
  dispatch: any,
  userData: NotificationUser,
) => {
  return dispatch(actionCreators.updateUser(userData));
};
export const fetchUserData = async (dispatch: Dispatch<any>, userName: string) => {
  return dispatch(actionCreators.fetchUserData(userName));
};

export const sendUnregisterUser = async (dispatch: Dispatch<any>, user: NotificationUser) => {
  return dispatch(actionCreators.sendUnregisterUser(user));
};

export const pingSchedulerService = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.pingSchedulerService());
};

export const clearRegistrationSuccessMessage = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.clearRegistrationSuccessMessage());
};

export const clearUpdateSuccessMessage = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.clearUpdateSuccessMessage());
};

export const clearUnregistrationSuccessMessage = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.clearUnregistrationSuccessMessage());
};

export const saveNotificationsReportFilter = async (
  dispatch: any,
  reportFilter: ReportFilter
) => {
  return dispatch(actionCreators.saveNotificationsReportFilter(reportFilter));
};

export const resetNotificationsReportFilter = async (
  dispatch: any
) => {
  return dispatch(actionCreators.resetNotificationsReportFilter());
};